import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, Col, Form, Row } from 'react-bootstrap';
import swal from 'sweetalert';
import { useAppContext } from '../../../../context';
import API from '../../../../api';

const ReviewForm = ({ setIsUpdated }) => {
    const {
        state: {
            user: { email, img }
        }
    } = useAppContext();

    const { id } = useParams();
    const navigate = useNavigate();

    const { register, handleSubmit, reset } = useForm();

    const [review, setReview] = useState({});
    const { name, address, description } = review;

    useEffect(() => {
        if (id) {
            API.get(`/userReview/${id}`)
                .then(res => {
                    setReview(res.data[0]);
                })
                .catch(err => console.log(err));
        }
    }, [id]);

    const onSubmit = (data) => {
        const loading = toast.loading('Uploading...Please wait!');

        const reviewData = {
            ...data,
            email: review.email || email,
            img: review.img || img
        };

        if (id) {
            API.patch(`/updateReview/${id}`, reviewData)
                .then(res => {
                    toast.dismiss(loading);

                    if (res) {
                        if (
                            data.name === name &&
                            data.address === address &&
                            data.description === description
                        ) {
                            toast.error("You haven't changed anything");
                        } else {
                            toast.success('Your review was successfully updated!');
                        }

                        navigate('/dashboard/review');
                    }
                })
                .catch(err => {
                    toast.dismiss(loading);
                    toast.error(err.message);
                });
        } else {
            setIsUpdated(false);

            API.post('/addReview', reviewData)
                .then(res => {
                    toast.dismiss(loading);

                    if (res) {
                        setIsUpdated(true);

                        swal(
                            "Success!",
                            "Your review has been submitted successfully. We appreciate your contribution.",
                            "success"
                        );

                        reset();
                    }
                })
                .catch(err => {
                    toast.dismiss(loading);
                    toast.error(err.message);
                });
        }
    };

    return (
        <section className="px-3">
            <div className="mx-auto reviewForm">
                <Form onSubmit={handleSubmit(onSubmit)} className="w-100">
                    <Row className="justify-content-center px-4">
                        <Form.Group as={Col} md={12}>
                            <Form.Label style={{ fontWeight: "bold" }}>
                                Your Name
                            </Form.Label>

                            <Form.Control
                                type="text"
                                defaultValue={name || ""}
                                {...register("name", { required: true })}
                                placeholder="Your Name"
                            />
                        </Form.Group>

                        <Form.Group as={Col} md={12}>
                            <Form.Label style={{ fontWeight: "bold" }}>
                                Address
                            </Form.Label>

                            <Form.Control
                                type="text"
                                defaultValue={address || ""}
                                {...register("address", { required: true })}
                                placeholder="Address"
                            />
                        </Form.Group>

                        <Form.Group as={Col} md={12}>
                            <Form.Label style={{ fontWeight: "bold" }}>
                                Description
                            </Form.Label>

                            <Form.Control
                                style={{ height: "10rem" }}
                                type="text"
                                defaultValue={description || ""}
                                as="textarea"
                                {...register("description", { required: true })}
                                placeholder="Description"
                            />
                        </Form.Group>
                    </Row>

                    <div className="text-center mt-1">
                        <Button type="submit" className="mainBtn">
                            {id ? 'Update' : 'Submit'}
                        </Button>
                    </div>
                </Form>
            </div>
        </section>
    );
};

export default ReviewForm;